/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type EditUserPreferencesInput = {
    readonly userId: string;
    readonly shareActivities?: boolean | null;
    readonly customOffers?: boolean | null;
    readonly clientMutationId?: string | null;
};
export type editUserPreferencesMutationVariables = {
    input: EditUserPreferencesInput;
};
export type editUserPreferencesMutationResponse = {
    readonly editUserPreferences: {
        readonly user: {
            readonly preferences: {
                readonly shareActivities: boolean | null;
            } | null;
        } | null;
    } | null;
};
export type editUserPreferencesMutation = {
    readonly response: editUserPreferencesMutationResponse;
    readonly variables: editUserPreferencesMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "EditUserPreferencesInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "preferences",
  "storageKey": null,
  "args": null,
  "concreteType": "UserPreferences",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "shareActivities",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "editUserPreferencesMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "editUserPreferences",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "EditUserPreferencesPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "editUserPreferencesMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "editUserPreferences",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "EditUserPreferencesPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "editUserPreferencesMutation",
    "id": "ferrum/245.0.0-2019-12-16T17:13:36.572Z/editUserPreferencesMutation",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '9bca29cf5d7e68a73a05b1fed8dc91c4';
export default node;
